export const EN2 = {

  //User Account Cancel Page

  accountCancelDisableAccountAsk: "¿Seguro que quieres darte de baja?",
  accountCancelDisableAccountTitle: "If you cancel your Correos ID account you will no longer have access to the following services:",
  accountCancelDisableAccountListTitle: "Note that:",
  accountCancelDisableAccountList: "We will delete your account.",
  accountCancelDisableAccountListEnterprise: "We will delete the companies you own and the application users related to them:",
  accountCancelDisableAccountP1: "Before you delete your Correos ID account we advise you to request and finalise the cancellation of the services where you are registered. If you would prefer to delete your Correos ID account now, click on Delete Account.",
  accountCancelDisableAccountP2: "*Don’t worry, you have {disableAccDays} days to recover your Correos ID account if you change your mind. You can recover the Correos ID account, but the other services may not save your data during these {disableAccDays} days.",
  accountCancelDisableAccountConfirm: "Delete Account",
  accountCancelDisableAccountLastWarn: "Si pulsas en aceptar confirmarás que quieres darte de baja",
  accountCancelDisableAccountRGPDWarn: "Before unsubscribing, please confirm your consents",

  //Enterprise Delete Page

  enterpriseDeleteEnterpriseTitle: "Are you sure you want to delete the company {enterpriseName}?",
  enterpriseDeleteEnterpriseTitleNoName: "Are you sure you want to delete the company?",
  enterpriseDeleteEnterpriseServicesTitle: "This company currently has access to the following services:",
  enterpriseDeleteEnterpriseText: "Once deleted you will not be able to recover the data referring to it",
  enterpriseDeleteButtonText: "Delete Company",
  enterpriseDeleteAlertMessageSuccess: "Enterprise Deleted Successfully",
  enterpriseDeleteAlertMessageError: "Error deleting enterprise",
  enterpriseDeleteAlertLastWarning: "Si pulsas en aceptar confirmarás que quieres borrar la empresa",

  //Privacy page

  privacyPermissionsManage: "Check the terms and conditions",
  privacyPrivacyManage: "Manage your privacy",
  privacyUnsuscribe: "Remove access to my details",
  privacySuscribe: "Permit access to my details",
  privacyDownload: "Download my privacy history",
  privacySuccessChange: "Privacy changed successfully",
  privacyWarning: "Attention!",
  privacyInfo1:
    "You are going to stop Mi Buzón (My Postbox) from accessing your Correos ID account. You will have to grant access again if you want to log into Mi Buzón. From the moment you click accept, we will no longer share your data with the service.",
  privacyInfo1_PARAM:
    "You are going to stop {APP} from accessing your Correos ID account. You will have to grant access again if you want to log into {APP}. From the moment you click accept, we will no longer share your data with the service.",
  privacyInfo2:
    "If you want Mi Buzón to delete your account, we can help you manage the deletion if you click here.",
  noState: "Without status",
  privacyTyCLink: "Terms and Conditions",
  privacyPrivacyLink: "Privacy Policies",
  privacySignedTyCPrivacy: "Signed:",
  privacySignedTyCPrivacyNoSigned: "Not signed",
  privacyIntroText: "Review the Terms and Conditions, as well as the Privacy Policies signed for each service you are subscribed to.",
  privacyEnterpriseIntroText: "Review the Terms and Conditions, as well as the Privacy Policies signed, for each service your company is subscribed to.",
  privacyIntroText2: "Manage the Privacy of Correos ID. You can review your Privacy consents and modify them if you wish.",
  privacyDataProtectionTitle: "Data Protection",
  privacyEnableAllText: "Enable all",
  privacyDisableAllText: "Disable all",

  //Team Page

  holderName: "First name",
  holderLastName: "1st Surname",
  holderSecondLastName: "2nd Surname",
  holderPrefix: "Prefix",
  holderMobile: "Mobile number",
  holderEmail: "Email",
  teamPageHolderTitle: "Account holder",
  teamPageAuthorizedTitle: "My authorised persons",
  teamPageAuthorizedName: "First name",
  teamPageAuthorizedLastName: "Surname(s)",
  teamPageAuthorizedState: "Status",
  teamPageAuthorizedRol: "Role",
  teamPageButtonAddEmployee: "Add Employee",
  teamPageButtonChangeHolder: "Change Holder",
  teamPageInsertMail: "Email",
  teamPageInsertNewMail: "Enter email address and role",
  teamPageSelectHolder: "Select the new holder",
  teamPageRol: "Role:",
  teamPageItemAdmin: "Administrator",
  teamPageItemAutorized: "Authorised person",
  teamPageChangeHolder: "Change Holder",
  teamPageInvitationSuccess: "Invitation sent successfully",
  teamPageTitularChangeSuccess: "Holder changed successfully",
  teamPageTitularEmpty: "The company does not have an account holder",
  revokeAdminPermissions: "Quitar persmisos de administrador",
  revokeAdminPermissionsQuestion:
    "Si continúas, quitarás permisos de administrador a este empleado, pero seguirá siendo empleado y perteneciendo al equipo",
  revokeAdminConfirm: "Permisos quitados correctamente",
  teamPageAddAdminTitle: "Dar permisos de administrador",
  teamPageAddAdminConfirmMsg:
    "Se va a enviar un email para que el usuario acepte el rol de administrador.",
  teamPageSubtitle: "Check and manage your company's team.",

  //unifyAccounts Page

  unifyAccountsTitle: "Unificación de cuentas",
  unifyAccountsPreviousInfoTitle: "Información previa",
  unifyAccountsPreviousInfo: "Información que puede ser de ayuda de cada usuario",
  unifyAccountsSubTitle: "Aquí puedes unir otra cuenta de usuario a la tuya, primero introduce el identificador de usuario de la cuenta que quieres unir.",
  unifyAccountsSubTitle2: "A continuación selecciona de entre las posibles opciones los valores, cuando sea posible, que quieres conservar.",
  unifyAccountsDataTitle: "Datos de Usuario",
  unifyAccountsDataSubTitle: "Haz clic sobre el campo para seleccionarlo o deseleccionarlo de modo que queden seleccionados los datos que quieras conservar",
  unifyAccountsData1: "Datos de {user1}",
  unifyAccountsData2: "Datos de {user2}",
  unifyAccountsMultidata: "Ahora selecciona y deselecciona entre los emails, teléfonos y direcciones de {user1} y {user2} teniendo en cuenta que puedes tener un máximo de 3 de cada uno. Ten en cuenta también que no puedes deseleccionar éstos últimos.",
  unifyAccountsMultidataTitle: "Emails, teléfonos y direcciones",
  unifyAccountsEmails1: "Emails de {user1}",
  unifyAccountsEmails2: "Emails de {user2}",
  unifyAccountsPhones1: "Teléfonos de {user1}",
  unifyAccountsPhones2: "Teléfonos de {user2}",
  unifyAccountsAddress1: "Direcciónes de {user1}",
  unifyAccountsAddress2: "Direcciónes de {user2}",
  unifyAccountsInfo1: "Información de {user1}",
  unifyAccountsInfo2: "Información de {user2}",
  unifyAccountsEnterpriseTitle: "Empresas",
  unifyAccountsEnterprise: "Aquí puedes ver las empresas de {user1} y las que se van a unificar del {user2}",
  unifyAccountsEnteprise1: "Empresas de {user1}",
  unifyAccountsEnteprise2: "Empresas de {user2}",
  unifyAccountsServiceTitle: "Servicios",
  unifyAccountsService: "Aquí puedes ver seleccionadas las aplicaciones a las que quedarás suscrito como {user1}. Ten en cuenta que, en caso de haberlas, a las aplicaciones sin seleccionar accederás como éste y no como {user2}.",
  unifyAccountsService1: "Aplicaciones suscritas de {user1}",
  unifyAccountsService2: "Aplicaciones suscritas de {user2}",
  unifyAccountsNoData: "Este usuario no tiene datos de este tipo",
  unifyAccountsSuccess: "Unificación finalizada",
  unifyAccountsText: "Las dos cuentas se han unificado, ya puedes seguir navegando",
  unifyAccountsRedirectWarn: "Tienes que indicar la pantalla a la que hay que redirigir",
  unifyAccountIncorrectId: "El identificador de usuario proporcionado no corresponde con ninguna cuenta",
  unifyAccountsMobileNoDoc: "Sin documento",
  unifyAccountsMobileuserData: "Escoge el usuario cuyos datos quieras conservar",
  unifyAccountsMobileuserDocument: "Escoge qué documento quieres conservar",
  unifyAccountsMobileuserEmail: "Selecciona los emails de {user2} que quieras incorporar",
  unifyAccountsMobileuserPhone: "Selecciona los teléfonos de {user2} que quieras incorporar",
  unifyAccountsMobileuserAddress: "Selecciona las direcciones de {user2} que quieras incorporar",
  unifyAccountsMobileuserEnterprise: "Estas son todas las empresas que tendrás",
  unifyAccountsMobileuserSubscription: "Estás son todas las aplicaciones a las que estarás suscrito",
  unifyAccountsMobileuserInfo: "Aquí aportamos información útil de cada usuario",
  unifyAccountsMobileUserInfoLogin: "Último login: ",
  unifyAccountsUserInfoLogin: "Último login",
  unifyAccountsMaxSelected: "The maximum number of emails, phones, and addresses you can have is 3 of each.",
  unifyAccountsUsersMandatory: "You cannot do without either the data you used to log in or the data you are going to unify.",
  unifyAccountsMoreThan3: "Keep in mind that you can have a maximum of 3 emails, 3 phones, and 3 addresses. You must remove as many as needed from the selected ones so that you end up with a maximum of 3 of each.",

  //Mobile unifyAccouts

  userName: "Nombre",
  userSurname1: "Apellido 1",
  userSurname2: "Apellido 2",
  userbirthDate: "Fecha de nacimiento",
  userNacionality: "Nacionalidad",
  userDocument: "NIF",
  userGender: "Sexo",
  userLanguage: "Idioma",
  stepPage: "Paso {stepPage} de {totalSteps}",
  userInfoMobile: "Información útil",
  userDataMobile: "Datos de usuario",
  emailsMobile: "Emails",
  phonesMobile: "Teléfonos",
  documentsMobile: "Documentos",
  addressMobile: "Direcciones",
  servicesMobile: "Suscripciones",
  enterpriseMobile: "Empresas",
  nextStep: "Siguiente",
  previousStep: "Anterior",
  saveMobile: "Guardar",

  //UploadDocumentModal

  uploadDocumentModalContent:
    "Please remember that if there is already a document of the same type in the verification process, that will be lost.",
  uploadDocumentModalTitle: "You are going to upload a new document",
  uploadDocumentFormatUnsupported: "Document format not supported.",
  uploadDocumentSuccess: "Document uploaded correctly",
  uploadDocumentError: "There was an error when uploading the file",

  // AtcPage - Stepper

  atcSearchUser: "Search for user",
  atcSelectAccount: "Select/Create account",
  atcUserVerify: "Verify user",
  atcUserData: "User information",
  atcIdentifierField:
    "Enter: DNI, Passport number, Phone number or Email address",
  atcOtpText: "To safeguard your identity, we will send you a code:",
  atcSendEmailButton: "SEND EMAIL",
  atcResendEmailButton: "RESEND EMAIL",
  atcSendSmsButton: "SEND SMS",
  atcResendSmsButton: "RESEND SMS",
  atcRegisterPagePrefix: "Prefix",
  atcRegisterPagePhone: "Telephone number",
  atcRegisterPageEmail: "Email",
  atcRegisterPageDniNie: "ID, Passport no.",
  atcRegisterPageSendOTP: "Enter the code sent",
  atcRegisterPageSendConsentSms: "SEND T&C SMS",
  atcRegisterPageResendConsentSms: "RESEND T&C SMS",
  atcCheckOtpCode: "CHECK CODE",
  atcAccept: "ACCEPT",
  atcClose: "CLOSE",
  atcCancel: "CANCEL",
  atcCreate: "CREATE",
  atcModify: "MODIFY",
  atcVerifyDocumentIdentifier: "VERIFY DNI/PASSPORT",
  atcPhoneError:
    "The telephone number is required, please enter a valid format",
  atcIdentifierDocumentError:
    "The DNI/Passport no. is required, please enter a valid format",
  atcEmailError: "The email address is required, please enter a valid format",
  atcNewAccount: "Create new account",
  atcRadioSelectAccount: 'Select your account or the option "New Account"',
  atcModalTitle: "Verified details",
  atcModalSubtitle: "Please select your account",
  atcModalEmailTitle: "Email addresses:",
  atcModalPhoneTitle: "Phone numbers:",

  //DialogMissingData

  dialogMissingDataText: "Hay acciones requeridas para el correcto funcionamiento de la aplicación:",
  dialogMissingDataTextTyC: "Para ello antes debes aceptar la privacidad y los términos y condiciones",
  dialogMissingDataTextDocument: "Necesitas verificar tu documento identificativo lo que implica que no puedes continuar a partir de aquí. Para poder verificarlo te recomendamos que te dirijas a tu oficina de correos más cercana.",
  dialogMissingDataTextNoHolder: "La empresa no tiene los datos obligatorios necesarios, ponte en contacto con el titular para poder continuar.",
  dialogMissingDataunsuscribedEnterprise: "Es necesario suscribirse a la aplicación",
  dialogMissingDatapendingEnterprisePrivacy: "Para ello antes debes aceptar la privacidad y los términos y condiciones",
  dialogMissingDatapendingUserPrivacy: "Para ello antes debes aceptar la privacidad y los términos y condiciones",
  dialogMissingDataincompleteUserData: "Rellenar datos de usuario obligatorios",
  dialogMissingDataincompleteEnterpriseData: "Rellenar datos de empresa obligatorios",
  dialogMissingDatapendingEnterprise: "Crear una empresa",
  dialogMissingDataverifyEmail: "Añadir un email verificado",
  dialogMissingDataverifyPhone: "Añadir un teléfono verificado",
  dialogMissingDataverifyAddress: "Añadir una dirección verificada",
  dialogMissingUserDataText:
    "The user information required for the service to function is not correct or incomplete. Please update your information.",
  dialogMissingEnterpriseDataText:
    "A company must be created for this service to work properly. Please create your company.",

  // Redirect Page

  redirectPageMissingParams: "Faltan parámetros",
  redirectPagePageNotFound: "La página no existe",

  // EnterpriseOauthLogin Page

  enterpriseOauthLoginPageError: "Faltan parámetros",
  redirectPageIdEnterpriseNotFound: "Se necesita el Id de empresa para acceder a esa página",
  redirectPageNotUserEnterprise: "La empresa indicada no pertenece al usuario",

  // ChooseEnterprise Page

  chooseEnterpriseNoSubsTitle: "Company not subscribed",
  chooseEnterpriseNoSubsText: "The company is not subscribed to the application, please contact the owner to subscribe and continue",
  chooseEnterpriseNoPrivTitle: "Privacy not signed",
  chooseEnterpriseNoPrivText: "The company has not signed the privacy policy, please contact the owner to sign it and continue",
  chooseEnterpriseNoDataTitle: "Required data",
  chooseEnterpriseNoDataText: "The company does not have all the required data, please contact the owner to complete them and continue",
  chooseEnterpriseOrgNoDataText: "The company does not have all the required data, please take the necessary steps to complete them and continue",

  // ResetPass Warn

  expiredPassTitle: "Contraseña caducada",
  expiredPassText: "La contraseña ha caducado, por favor, crea una nueva",

  //UserVerifications2FA
  verifications2FATitle: "Configura tu doble factor de autenticación",
  verifications2FAImageText: "Manage your Two-Factor Authentication. Enable or disable it for each of the services you have contracted, keeping in mind that there are services where you will not be able to disable it, as it is mandatory by regulation.",
  verifications2FAConfigText: "Servicios contratados",
  verifications2FASetPhone: "Configura tu teléfono",
  verifications2FASetEmailTitle: "Confirma tu identidad",
  verifications2FASetEmailText: "Mandaremos un código de verificación a tu email",
  verifications2FASetEmailConfText: "Mandaremos un código de verificación a tu email para confirmar tu identidad",
  verifications2FASetEmailOtp: "Código de verificación",
  verifications2FASetPhoneTitle: "Configura tu teléfono",
  verifications2FASetPhoneText: "Mandaremos un código de verificación a tu teléfono",
  verifications2FASetPhoneOtp: "Código de verificación",
  verifications2FASetPhonConfirmation: "Ya tienes configurado un teléfono para el doble factor de autenticación. Si estabas intentando hacer login en un servicio, por favor, vuelve a intentarlo.",
  verifications2FAConfigSuccess: "Tu configuración para el doble factor de autenticación se ha actualizado correctamente",

  // Login2FA

  login2FASetPhoneTitle: "Configura tu teléfono",
  login2FASetPhoneText: "Esta aplicación requiere un doble factor de autenticación y necesitas configurar tu teléfono. Para ello accede a la configuración de tu cuenta pulsando en 'Aceptar'.",
  login2FASendPhoneTitle: "Segundo factor de autenticación",
  login2FASendText: "Esta aplicación requiere un segundo factor de autenticación, introduce el código de verificación que enviaremos a tu",
  login2FASetPhoneOtp: "Código de verificación",
  login2FASetPhoneError: "No se ha podido validar el teléfono. Por favor, inténtalo de nuevo.",

  // Oauth - ACM
  loginACMTitle: "Login failed",
  loginACMText: "There was a problem with the data provided, please try again",
  generalACMTitle: "Attention",
  generalACMTextGo: "In order to access the application you must log in again",
  generalACMTextNoGo: "Return to the app to log in",

  // GeneralWarning
  generalWarningPassText: "An error occurred while changing the password. If you received the validation code you may have entered it incorrectly, or perhaps it could be that the {dataType} you entered is incorrect, in which case make sure you entered it correctly.",
  generalWarningRegistryText: "There was an error creating the account. If you have received the validation code, perhaps you have entered it incorrectly, or perhaps it could be that the email account you have indicated is already registered in CorreosID, in which case you should recover the password.",
  generalWarningVerifyText: "An error has occurred when verifying the {dataType}. If you have received the validation code, perhaps you have entered it incorrectly, or perhaps it could be that the {dataType} that you have indicated is already verified in CorreosID.",

  // GoToUnifyAccounts
  goToUnifyAccountsButton: "Unify Accounts",
  goToUnifyAccountsTitle1: "Verify your identity",
  goToUnifyAccountsTitle2: "Verify account",
  goToUnifyAccountsText1: "In order to unify accounts, you must verify your identity",
  goToUnifyAccountsText2: "In order to unify accounts, you must verify the account to be unified",
  goToUnifyAccountsData: "Data to verify",
  goToUnifyAccountsOtpError: "An error occurred while verifying the {dataType}",
  goToUnifyAccountsVerifyDataError: "The data you want to unify '{verifyData}' is already verified in your account",

  //SystemUser
  systemUserPageSubtitle: "Check and manage your applications. Remember that you can have a maximum of 3.",
  systemUserPageNoApps: "You have no applications created",
  systemUserPageName: "Name",
  systemUserPageClientId: "Client Id",
  systemUserPageCreateTitle: "Application Creation",
  systemUserPageCreateLabel: "Application Name",
  systemUserPageCreateNameExists: "You already have a system user with that name",
  systemUserPageCreateData: "These are the details of the created application, do not forget to save the 'Client Secret' key as, once this window is closed, you will not be able to retrieve it again",
  systemUserPageCreateClientId: "client_id",
  systemUserPageCreateClientSecret: "client_secret",
  systemUserPageCreated: "Application created successfully",
  systemUserPageDeleteTitle: "Delete system user",
  systemUserPageDeleteText: "Are you sure you want to delete the system user {client_id}?",
  systemUserPageDeleteSuccess: "System user successfully deleted",
  systemUserPageClientSecretChanged: "A new client_secret has been generated, don't forget to save the key because, once this window is closed, you won't be able to retrieve it again:",
  systemUserPageClientSecret: "client_secret",
  systemUserPageClientSecretText: "Are you sure you want to generate a new client_secret for the system user {user}? The current client_secret will no longer be valid.",
  systemUserPageClientSecretTitle: "Generate client_secret",
  systemUserPageClientSecretCopySuccess: "Data copied to clipboard",
  systemUserPageClientSecretCopyError: "Error copying data to clipboard",
  systemUserPageClientSecretRestore: "Reset client_secret",

  //EnterpriseCreate
  enterpriseCreateTitle: "Create company",
  enterpriseSubtitle: "Fill in the details of the company you want to create",

  //EnterpriseData
  entepriseDataTitle: "Company data",
  enterpriseDataSubtitle: "Check and edit your company's data.",

  //LoginSelectOneEmail
  loginSelectOneEmailTitle: "Select an email",
  loginSelectOneEmailText: "From now on, you can only have one email associated with your Correos ID account. Select the email you want to keep and we will remove the rest.",
  loginSelectOneEmailSelect: "Select email",
  loginSelectOneEmailNotVerified: "The selected email is not verified, please verify the email to continue",

  //LoginSelectOnePhone
  loginSelectOnePhoneTitle: "Select a phone number",
  loginSelectOnePhoneText: "From now on, you can only have one phone number associated with your Correos ID account. Select the phone number you want to keep and we will remove the rest.",
  loginSelectOnePhoneSelect: "Select phone number",
  loginSelectOnePhoneNotVerified: "The selected phone number is not verified, please verify the phone number to continue",
  loginSelectOnePhoneNoPhones: "No phone",
  loginSelectOnePhoneNoPhonesTitle: "No phone associated",
  loginSelectOnePhoneNoPhonesText: "If you choose to continue, you will not have any phone number associated with your account. To associate a new phone number, go to the 'Verifications' section and set it up there.",
};
